import { useCopy } from "../i18n/copy";

export const Marquee = () => {
  const { items } = useCopy("marquee");
  return (
    <div className="overflow-hidden border-y hairline bg-paper-tint py-4" aria-hidden="true">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((n) => (
          <div key={n} className="flex shrink-0 items-center">
            {items.map((item) => (
              <span key={`${n}-${item}`} className="flex items-center">
                <span className="px-8 font-mono text-xs tracking-[0.25em] uppercase text-slate-600 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-terracotta/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
